module.exports = __webpack_public_path__ + "img/secure.f782a105.svg";